import { render, staticRenderFns } from "./Controlling.vue?vue&type=template&id=aa8f508c&scoped=true&"
import script from "./Controlling.vue?vue&type=script&lang=js&"
export * from "./Controlling.vue?vue&type=script&lang=js&"
import style0 from "./Controlling.vue?vue&type=style&index=0&id=aa8f508c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8f508c",
  null
  
)

export default component.exports